// Utility functions

// Extract initials from user name
export function getUserInitials(name) {
  if (!name) return 'U';
  
  const parts = name.trim().split(' ');
  
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  
  return name.substring(0, 2).toUpperCase();
}

// Format timestamp for messages
export function formatTimestamp(date) {
  if (!date) return 'Just now';
  
  const now = new Date();
  const messageDate = new Date(date);
  
  // Check if date is valid
  if (isNaN(messageDate.getTime())) {
    return 'Just now';
  }
  
  const diffMs = now - messageDate;
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffMins < 1440) return `${Math.floor(diffMins / 60)}h ago`;
  
  return messageDate.toLocaleDateString();
}

// Scroll to bottom of element
export function scrollToBottom(element, smooth = true) {
  if (!element) return;
  
  element.scrollTo({
    top: element.scrollHeight,
    behavior: smooth ? 'smooth' : 'auto',
  });
}
